import { Box, Button, CircularProgress, Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useAppSelector } from 'commons/store/hooks';
import { selectCurrentSection, selectSurvey } from 'features/survey/redux/surveySlice';
import React, { useState } from 'react';
import {
    StyledSurveyPanel,
    StyledSurveyTitle,
    StyledSurveySubTitle,
    StyledSurveySectionsTitle,
    StyledSurveySectionsTitleWrapper,
    StyledSurveySectionsWrapper,
    StyledSurveyTitleFull,
    StyledButtonShow,
    StyledSurveyTitleSmall,
    StyledSurveyTitleRand,
    StyledSurveySubTitleSmall,
} from '../Form.styled';
import { MenuItem } from './MenuItem';
import DateTime from "core/helpers/date/DateTime";
import { COLOR_SECONDARY_DARK, DATETIME_FORMAT } from "commons/constants/env";
import { roles } from 'commons/auth/roles';
import { selectUserProfile } from "core/redux/userSlice";
import { useTranslation } from "react-i18next";

interface Props {
    selectedSegment: any;
    selectedSection: any;
    setSelectedSection: (selectedSection: any) => void;
    isDataLoading: boolean;
    setIsDataLoading: (isDataLoading: boolean) => void;
}

export const surveyStatusDictionary = [
    'active',
    'signed',
    'completed',
    'failure',
    'blocked'
];

export const LeftPanel: React.FC<Props> = ({
   selectedSegment,
   selectedSection,
   isDataLoading,
   setIsDataLoading,
   setSelectedSection
}) => {
    /** This is current selected section data */
    const currentSection = useAppSelector(selectCurrentSection);

    /** Current survey all data */
    const survey = useAppSelector(selectSurvey);

    /** Current user profile */
    const userProfile = useAppSelector(selectUserProfile);

    const [expandDetails, setExpandDetails] = useState<boolean>(false);
    const [expandSections, setExpandSections] = useState<boolean>(true);
    const [showPanel, setShowPanel] = useState(false)
    const { t } = useTranslation();

    /** Display count elements */
    const displayCount = () => {
        return userProfile.roles.some(
            (role: string) => roles.admin.includes(role) || roles.control.includes(role)
        );
    }

    return (
        <StyledSurveyPanel show={showPanel}>
            <StyledButtonShow>
                <Button onClick={() => setShowPanel(!showPanel)} variant={'outlined'}
                    style={{ position: 'fixed', bottom: '20px', right: '10px' }}>
                    {showPanel ? t('hide') : t('show')}
                </Button>
            </StyledButtonShow>

            <Box>
                <Box>
                    <StyledSurveyTitle>{t('Survey')}</StyledSurveyTitle>
                    <StyledSurveySubTitle>{survey?.form?.name || '-'}</StyledSurveySubTitle>
                </Box>
                {/*<Box mt="15px">*/}
                {/*    <StyledSurveyTitle><b>{t('screening-number')}</b> / {t('randomization')}</StyledSurveyTitle>*/}
                {/*    <StyledSurveySubTitle>*/}
                {/*        {survey?.screeningNumber || '-'} / <StyledSurveyTitleRand>{survey?.randomId || '-'}</StyledSurveyTitleRand>*/}
                {/*    </StyledSurveySubTitle>*/}
                {/*</Box>*/}
            </Box>

            <Box mt={3}>
              <StyledSurveySectionsTitleWrapper onClick={() => setExpandDetails(!expandDetails)}>
                <StyledSurveySectionsTitle>{t('details')}</StyledSurveySectionsTitle>
                {expandDetails ? <ExpandLess /> : <ExpandMore />}
              </StyledSurveySectionsTitleWrapper>

              <Collapse in={expandDetails} unmountOnExit>
                <Box mt="15px">
                  <StyledSurveyTitle>{t('created-date')}</StyledSurveyTitle>
                  <StyledSurveySubTitle>
                    {DateTime.toIso(survey?.createdAt, DATETIME_FORMAT) || '-'}
                  </StyledSurveySubTitle>
                </Box>

                <Box mt="15px" pt={'15px'} style={{borderTop: `1px solid ${COLOR_SECONDARY_DARK}`}}>
                    <StyledSurveyTitle>{t('visible')}: {currentSection?.name}</StyledSurveyTitle>
                </Box>

                <Box mt="15px">
                    <StyledSurveyTitle>{t('status')}: {t(surveyStatusDictionary[survey?.status])}</StyledSurveyTitle>
                </Box>

                <Box mt="15px" pt={'15px'} style={{borderTop: `1px solid ${COLOR_SECONDARY_DARK}`}}>
                {/*    <StyledSurveyTitleFull*/}
                {/*        onClick={() => window.open(`${process.env.REACT_APP_API_URL}/api/surveys/${survey?.id}/export.xlsx`, "_blank")}>*/}
                {/*        {t('export-to')} .xlsx*/}
                {/*    </StyledSurveyTitleFull>*/}
                </Box>
              </Collapse>
            </Box>

            <Box mt={3} mb={5}>
                {selectedSegment?.sections && (
                    <>
                        <StyledSurveySectionsTitleWrapper onClick={() => setExpandSections(!expandSections)}>
                            <StyledSurveySectionsTitle>{t('sections')}</StyledSurveySectionsTitle>
                            {isDataLoading ? (
                                <CircularProgress color="inherit" size={12} />
                            ) : (
                                <> {expandSections ? <ExpandLess /> : <ExpandMore />} </>
                            )}
                        </StyledSurveySectionsTitleWrapper>
                    </>
                )}

                <Box mt="20px">
                    <Collapse in={expandSections} unmountOnExit>
                        <StyledSurveySectionsWrapper>
                            {selectedSegment?.sections && (
                                <Box>
                                    {selectedSegment?.sections.map((section: any) => (
                                        <MenuItem
                                            key={section?.id}
                                            section={section}
                                            selectedSection={selectedSection}
                                            setSelectedSection={setSelectedSection}
                                            isDataLoading={isDataLoading}
                                            setIsDataLoading={setIsDataLoading}
                                            displayCount={displayCount()}
                                        />
                                    ))}
                                </Box>
                            )}
                        </StyledSurveySectionsWrapper>
                    </Collapse>
                </Box>
            </Box>
        </StyledSurveyPanel>
    );
};
